interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
}

const sizes = {
  sm: 40,
  md: 64,
  lg: 96,
  xl: 128,
};

export function Logo({ size = 'md', showText = false }: LogoProps) {
  const dimension = sizes[size];

  return (
    <div className="flex flex-col items-center gap-3">
      <svg
        width={dimension}
        height={dimension}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Blue circle */}
        <circle
          cx="50"
          cy="50"
          r="46"
          stroke="#3B82F6"
          strokeWidth="4"
          fill="none"
        />

        {/* Red heart */}
        <path
          d="M50 80C50 80 20 55 20 38C20 28 28 20 38 20C44 20 49 23 50 28C51 23 56 20 62 20C72 20 80 28 80 38C80 55 50 80 50 80Z"
          fill="#EF4444"
        />

        {/* ECG line */}
        <path
          d="M25 50H38L42 38L46 58L50 42L54 54L58 46L62 50H75"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </svg>

      {showText && (
        <span className="text-xl font-bold text-gray-800">
          Health Assistant Tool
        </span>
      )}
    </div>
  );
}
